<div [formGroup]="fg">
  <!-- URL Section -->
  <div class="action-setting">
    <label class="action-setting-title">
      {{ 'commonActions.sendWebhookAction.url' | labelsProvider }}<span class="required">*</span>
    </label>
    <input
      class="action-setting-input"
      formControlName="url"
      type="text"
      placeholder="Enter a url"
      [ngClass]="{
        'input-form-invalid': fg.controls['url'].invalid && (fg.controls['url'].dirty || fg.controls['url'].touched),
      }"
    />
  </div>

  <!-- Secret Headers Section -->
  <div class="action-setting headers-section">
    <label class="action-setting-title">
      {{ 'commonActions.sendWebhookAction.secretHeaders' | labelsProvider }}
      <span class="info-text">
        <lucide-icon class="info-icon" name="info" [size]="14"></lucide-icon>
        {{ 'commonActions.sendWebhookAction.secretHeadersInfo' | labelsProvider }}
      </span>
    </label>

    <div class="headers-container" formArrayName="secretHeaders">
      <div class="header-row header-labels" *ngIf="secretHeaders.length > 0">
        <span class="header-name-label">{{ 'commonActions.sendWebhookAction.headerName' | labelsProvider }}</span>
        <span class="header-value-label">{{ 'commonActions.sendWebhookAction.headerValue' | labelsProvider }}</span>
        <span class="header-action-label"></span>
      </div>

      <app-webhook-header
        *ngFor="let header of secretHeaders.controls; let i = index"
        [headerGroup]="$any(header)"
        valueInputType="password"
        valuePlaceholder="Header value"
        (remove)="removeSecretHeader(i)"
      />

      <button type="button" class="add-header-btn" (click)="addSecretHeader()" [disabled]="!canAddSecretHeader">
        <img src="assets/images/common/plus.svg" alt="Add" />
        {{ 'commonActions.sendWebhookAction.addHeader' | labelsProvider }}
      </button>
    </div>
  </div>

  <!-- Custom Headers Section -->
  <div class="action-setting headers-section">
    <label class="action-setting-title">
      {{ 'commonActions.sendWebhookAction.customHeaders' | labelsProvider }}
    </label>

    <div class="headers-container" formArrayName="customHeaders">
      <div class="header-row header-labels" *ngIf="customHeaders.length > 0">
        <span class="header-name-label">{{ 'commonActions.sendWebhookAction.headerName' | labelsProvider }}</span>
        <span class="header-value-label">{{ 'commonActions.sendWebhookAction.headerValue' | labelsProvider }}</span>
        <span class="header-action-label"></span>
      </div>

      <app-webhook-header
        *ngFor="let header of customHeaders.controls; let i = index"
        [headerGroup]="$any(header)"
        valueInputType="text"
        valuePlaceholder="Header value (optional)"
        (remove)="removeCustomHeader(i)"
      />

      <button type="button" class="add-header-btn" (click)="addCustomHeader()" [disabled]="!canAddCustomHeader">
        <img src="assets/images/common/plus.svg" alt="Add" />
        {{ 'commonActions.sendWebhookAction.addHeader' | labelsProvider }}
      </button>
    </div>
  </div>
</div>
